import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Race-safe: if we have a token in storage but user hasn't been hydrated yet,
  // keep showing the spinner instead of redirecting to /login.
  const hasToken = !!(typeof window !== 'undefined' && localStorage.getItem('token'));

  if (loading || (!isAuthenticated && hasToken)) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Laden...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    sessionStorage.setItem('returnAfterLogin', location.pathname);
    return <Navigate to="/login" replace />;
  }

  return children;
};
